import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Identification, RetakeRequest, Session } from 'src/app/queries/generated';

@Component({
  selector: 'lv-retake-request-submitted',
  templateUrl: './retake-request-submitted.component.html',
  styleUrls: ['./retake-request-submitted.component.scss'],
  imports: [CommonModule, TranslateModule]
})
export class RetakeRequestSubmittedComponent {
  @Input() session!: Session;
  @Input() retakeRequest!: RetakeRequest;
  @Input() identification!: Identification;
}
